var Handlebars = require("handlebars/runtime");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<form class=\"user-login-form\">\n	"
    + ((stack1 = (lookupProperty(helpers,"global:sanitize")||(depth0 && lookupProperty(depth0,"global:sanitize"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"ssoContent") : depth0),{"name":"global:sanitize","hash":{},"data":data,"loc":{"start":{"line":2,"column":1},"end":{"line":2,"column":33}}})) != null ? stack1 : "")
    + "\n</form>\n";
},"useData":true});